import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { Option } from '@mews-commander/types';
import { ServiceTimeClass } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { createOption } from '@mews-commander/ui';

const timeClassTextKeyMap = {
    [ServiceTimeClass.Night]: TextKey.Night,
    [ServiceTimeClass.Day]: TextKey.Day,
    [ServiceTimeClass.Month]: TextKey.Month,
    [ServiceTimeClass.Hour]: TextKey.Hour,
};

const defaultBookablePeriods = [
    ServiceTimeClass.Night,
    ServiceTimeClass.Day,
    ServiceTimeClass.Month,
    ServiceTimeClass.Hour,
];

interface GetBookablePeriodOptionsParams {
    localizeText: (textKey: Mews.TextKey) => string;
}

export const getBookablePeriodOptions = ({ localizeText }: GetBookablePeriodOptionsParams): Array<Option> =>
    pipe(
        defaultBookablePeriods,
        array.map((timeClass) =>
            createOption({
                value: timeClass,
                label: localizeText(timeClassTextKeyMap[timeClass]),
            })
        )
    );
